/**
 * Ce inseamna „verificare reusita" dupa T1 (SP-01): o SESIUNE, nu un token de resetare.
 *
 * 🔴 Contractul se schimba sub noi. Pana la T1, `/api/auth/otp/verify` intorcea
 * `{ resetToken }` si fluxul se termina pe „alege o parola noua". Dupa T1 intoarce
 * acelasi corp ca `/api/auth/login` — `AuthenticationResponse`. Modulul asta e locul
 * unde se decide daca raspunsul e o sesiune, si e pur ca sa poata fi testat: suita
 * ruleaza pe `environment: 'node'`, fara jsdom, deci nimic montat.
 *
 * 🔴 Tipul generat al raspunsului e `{ [key: string]: unknown }` (spec-ul nu-l descrie),
 * iar `AuthenticationResponse` are AMBELE campuri optionale (`token?`, `refreshToken?`).
 * Deci tipurile nu ne apara de un raspuns fara tokenuri — verificarea trebuie sa fie la
 * RULARE, exact ca la login („Authentication response missing tokens"). Si nu scriem
 * DTO-uri de mana: cand B1 are ramura stabila, tipurile se regenereaza.
 */

export interface SesiuneOtp {
    token: string;
    refreshToken: string;
}

/** Mesajul aratat omului cand serverul spune „cod bun" dar nu trimite sesiunea. */
export const MESAJ_FARA_SESIUNE = 'Verificarea a reușit, dar nu am primit sesiunea. Încearcă din nou.';

function sirNevid(valoare: unknown): string | null {
    if (typeof valoare !== 'string') return null;
    const curat = valoare.trim();
    return curat ? curat : null;
}

/**
 * Ia din raspunsul lui `/verify` cele doua tokenuri, sau arunca.
 *
 * Un raspuns partial (doar `token`, doar `refreshToken`) e tratat ca esec: cu unul
 * singur, sesiunea porneste si moare la primul refresh, adica omul e deconectat in
 * mijlocul unei pagini in loc sa vada eroarea aici. Vechea forma — `{ resetToken }` —
 * pica si ea, deliberat: daca backendul ramane pe contractul vechi, vrem sa se vada,
 * nu sa aterizam tacut intr-un flux care nu mai exista.
 */
export function sesiuneDinRaspuns(corp: unknown): SesiuneOtp {
    if (!corp || typeof corp !== 'object') throw new Error(MESAJ_FARA_SESIUNE);

    const camp = corp as { token?: unknown; refreshToken?: unknown };
    const token = sirNevid(camp.token);
    const refreshToken = sirNevid(camp.refreshToken);
    if (!token || !refreshToken) throw new Error(MESAJ_FARA_SESIUNE);

    return { token, refreshToken };
}
